import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useEffect } from 'react';
import { components } from 'react-select';
import { FixedSizeList } from 'react-window';
import memoize from 'memoize-one';
import { debounce } from 'lodash';
import CustomOption from './CustomOption.js';
import CustomOptionMulti from './CustomOptionMulti.js';
import MultiSelectHeader from './MultiSelectHeader.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-truncated-tooltip-text';
import '../../../Checkbox/DSCheckbox.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '../../../Checkbox/elements/CheckMark.js';
import 'styled-components';
import '../../../Checkbox/defaultProps.js';
import '../../../prop-types-cc01d273.js';
import '../../../Checkbox/props.js';

var createItemData = memoize(function (items, options) {
  return {
    items: items,
    options: options
  };
});

var scrollTo = function scrollTo(listRef, type) {
  if (listRef && listRef.current && listRef.current.props) {
    var items = listRef.current.props.itemData.items;
    var index = items.findIndex(function (item) {
      return item.props.isFocused;
    });
    listRef.current.scrollToItem(index, type);
  }
}; // const scrollToMouse = debounce(scrollTo, 500)


var scrollToKeyword = debounce(scrollTo, 50);

var MenuList = function MenuList(props) {
  var listRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inside = _useState2[0],
      setInside = _useState2[1];

  var handleKeyDown = function handleKeyDown() {
    setInside(false);
  };

  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  });
  var options = props.children,
      selectProps = props.selectProps,
      isMulti = props.isMulti;
  var customMenuItemOptions = selectProps.customMenuItemOptions;
  var _customMenuItemOption = customMenuItemOptions.itemSize,
      itemSize = _customMenuItemOption === void 0 ? 35 : _customMenuItemOption;
  var itemData = createItemData(options, customMenuItemOptions);
  var maxOptionsScreen = 10;
  var safeOptionLength = options.length || 1;
  var height = itemSize * (safeOptionLength < maxOptionsScreen ? safeOptionLength : maxOptionsScreen);
  var RenderOption = !isMulti ? CustomOption : CustomOptionMulti;
  if (!options.length) return /*#__PURE__*/React.createElement(components.MenuList, props);

  if (listRef && listRef.current && !inside) {
    scrollToKeyword(listRef, 'center'); // use autoScroll
  }

  return /*#__PURE__*/React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      setInside(false);
    }
  }, isMulti && /*#__PURE__*/React.createElement(MultiSelectHeader, props), /*#__PURE__*/React.createElement(FixedSizeList, {
    ref: listRef,
    className: "combobox-menu-list ".concat(isMulti && 'combobox-menu-list-is-multi'),
    height: height,
    itemCount: options.length,
    itemData: itemData,
    itemSize: itemSize,
    onScroll: function onScroll() {
      setInside(true);
    },
    useIsScrolling: true
  }, RenderOption));
};

export default MenuList;
//# sourceMappingURL=MenuList.js.map
